import { useEffect } from 'react';
import { REMOTE_OPENED } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useDispatch } from 'calling-remote-common/hooks/useDispatch';
import { sendCrossTabMessage } from 'worker-connection-library/calling-cross-tab-utils/sendCrossTabMessage';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { useOpenCloseRemote } from './useOpenCloseRemote';
export const useOpenedWindowExists = () => {
  const [, dispatch] = useThirdPartyWidgetDetailsContext();
  const {
    updateWidgetDetails
  } = useDispatch(dispatch);
  const {
    setHasThirdPartyOpened
  } = useOpenCloseRemote();
  useEffect(() => {
    sendCrossTabMessage(createBroadcastMessage({
      type: REMOTE_OPENED,
      payload: {}
    }));
  }, [setHasThirdPartyOpened, updateWidgetDetails]);
};